import * as firebase from 'firebase'

export default {
  state: {
    user: null,
    userContents: [],
    email: null,
    admin: false,
    curator: false
  },
  mutations: {
    setAdmin(state, payload) {
      state.admin = payload
    },
    setCurator(state, payload) {
      state.curator = payload
    },
    setUserContents(state, payload) {
      state.userContents = payload
    },
    setEmail(state, payload) {
      state.user.email = payload
    },
    assignContentToUser(state, payload) {
      const id = payload.id
      state.user.fbKeys[id] = payload.fbKey
    },
    assignUserEmail(state, payload) {
      
      state.email = payload
    },

    setUser(state, payload) {
      state.user = payload
    }

  },
  actions: {
    assignUserEmail({ commit, getters }, payload) {
      commit('setLoading', true)
      const user = getters.user
      const email=firebase.auth().currentUser.email
      console.log("XXXXX",email,payload,user)
      firebase
        .database()
        .ref('/users/' + user.id)
        .child('/email/')
        .set(email)
        .then(data => {
          commit('setLoading', false)
          commit('assignUserEmail', { email })
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
    },
    assignContentToUser({ commit, getters }, payload) {
      commit('setLoading', true)
      const user = getters.user
      firebase
        .database()
        .ref('/users/' + user.id)
        .child('/content/')
        .push(payload)
        .then(data => {
          commit('setLoading', false)
          commit('assignContentToUser', { id: payload, fbKey: data.key })
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
    },
    getUserContent({ commit, getters }, payload) {
      commit('setLoading', true)
      const user = getters.user
      firebase
        .database()
        .ref('/users/' + user.id)
        .child('/content/')
        .push(payload)
        .then(data => {
          commit('setLoading', false)
          commit('assignContentToUser', { id: payload, fbKey: data.key })
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
    },
    getContact({ commit},userID){
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        // Do something here... lets say, a http call using vue-resource
        
        firebase.database()
          .ref('/users/' + userID + '/email/')
          .once('value')
          .then(data => {
            commit('setLoading', false)
            console.log(data.val())
            resolve(data.val())

          }, error => {
            // http failed, let the calling function know that action did not work out
            commit('setLoading', false)
            reject(error);
          })
      })
      console.log("GET CONTACT For ",userID)
     // this.$store.commit('setLoading', true)
     
      // commit('setLoading', false)
    },

    signUserUp({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.password)
        .then(user => {
          commit('setLoading', false)
          const newUser = {
            id: user.uid,
            admin: false,
            user: true,
            fbKeys: {}
          }
          firebase
            .database()
            .ref('/users/' + user.uid)
            .child('/admin/')
            .set(false)
            .then(data => {
              console.log("Setting admin", user.id, false);
              commit('setUser', newUser)
            })
        })
        .catch(error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log(error)
        })
    },
    signUserUpGoogle({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      console.log("SIGN UP WITH GOOGLE");
      var provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().signInWithPopup(provider).then(function(result) {
        // This gives you a Google Access Token. You can use it to access the Google API.
        var token = result.credential.accessToken;
        // The signed-in user info.
        var user = result.user
        const newUser = {
          id: user.uid,
          admin: false,
          user: true,
          fbKeys: {}
        }
        firebase
          .database()
          .ref('/users/' + user.uid)
          .child('/user/')
          .set(true)
          .then(data => {

            commit('setUser', newUser)
          })
          // ...
      }).catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential;
        // ...
      });
      commit('setLoading', false)
    },
    signUserIn({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then(user => {
          commit('setLoading', false)
          const newUser = {
            id: user.uid,
            fbKeys: {}
          }
          commit('setUser', newUser)
        })
        .catch(error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log(error)
        })
    },
    autoSignIn({ commit }, payload) {
      commit('setUser', { id: payload.uid, fbKeys: {} })
    },
    forgotPassword({},emailAddress){
      var auth=firebase.auth();
      console.log("forgot",emailAddress)
      auth.sendPasswordResetEmail(emailAddress).then(function(message){
        console.log("Email SENT")
        alert("An email has been sent to "+emailAddress+" please follow the link to reset your password")
      }).catch(function(error){
        console.log("EMAIL ERROR",error)
        alert(error.message)
      })
    },
    fetchUserData({ commit, getters }) {
      commit('setLoading', true)
      let uploadedContent = []


      firebase.database()
        .ref('/users/' + getters.user.id + '/content/')
        .once('value')
        .then(data => {
          const dataPairs = data.val()
          let swappedPairs = {}
          for (let key in dataPairs) {
            uploadedContent.push(dataPairs[key])
            swappedPairs[dataPairs[key]] = key
          }
          const updatedUser = {
            id: getters.user.id,
            uploadedContent: uploadedContent,
            fbKeys: swappedPairs
          }
          commit('setLoading', false)
          commit('setUser', updatedUser)
        }).then(() => {
          firebase.database()
            .ref('/users/' + getters.user.id + '/admin/')
            .once('value')
            .then(data => {
              commit('setAdmin', data.val())
              firebase.database()
                .ref('/users/' + getters.user.id + '/curator/')
                .once('value')
                .then(data => {
                  commit('setCurator', data.val())
                  firebase.database()
                    .ref('/users/' + getters.user.id + '/email/')
                    .once('value')
                    .then(data => {
                      commit('setEmail', data.val())

                    })

                
                })

            })
        })

      .catch(error => {
        commit('setLoading', false)
        console.log(error)
      })
    },
    loadUserInfo({ commit }, uid) {
      commit('setLoading', true)
      console.log( firebase
        .auth()
        .currentUser.email)
        
       commit('setLoading', false)
    },
    loadUserContents({ commit }, id) {
      commit('setLoading', true)
      firebase
        .database()
        .ref('content')
        .once('value')
        .then(data => {
          const contents = []
          const obj = data.val()
          for (let key in obj) {
            console.log(obj[key].creatorId, "   ", id)
            if (id == obj[key].creatorId) {
              contents.push({
                id: key,
                title: obj[key].title,
                description: obj[key].description,
                artist: obj[key].author,
                videoUrl: obj[key].videoUrl,
                imageUrl: obj[key].imageUrl,
                date: obj[key].date,
                creatorId: obj[key].creatorId
              })
            }
          }
          commit('setLoading', false)
          commit('setUserContents', contents)
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
    },
    logout({ commit }) {
      firebase.auth().signOut()
      commit('setUser', null)
      console.log(LOGOUT)
    }
  },
  getters: {
    email(state){
      
    },
    user(state) {
      return state.user
    },
    userAdmin(state) {
      return state.admin
    },
    userCurator(state) {
      return state.curator
    },
    userContents(state) {
        return state.userContents.sort(function(contentA, contentB)  {
          let d1= new Date(contentA.date)
          let d2 = new Date(contentB.date)
          return d2.getTime() - d1.getTime()
        })
    },

  }
}


// WEBPACK FOOTER //
// ./src/store/user/index.js